/**
 * Active additional terms as sent to estimate/quote email and PDF endpoints.
 * JSON.stringify omits keys whose value is undefined; the API may still read those
 * properties when merging templates, which surfaces as the literal "undefined" in emails.
 */
export function activeAdditionalTermsForPayload(terms: unknown[]): Record<string, unknown>[] {
  return (terms as Record<string, unknown>[])
    .filter((term) => term && term.active === true)
    .map((term) => ({
      ...term,
      text: term.text != null ? String(term.text) : "",
      label: term.label != null ? String(term.label) : "",
      type: term.type != null ? String(term.type) : "",
      source: term.source != null ? String(term.source) : "",
    }));
}
